
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/tforce",
      function () {
        return require("private-next-pages/partners/tforce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/tforce"])
      });
    }
  